export const AI_ENTITY_TYPE = {
    Invoice: 'invoice',
    Quote: 'quote',
    CreditNote: 'credit_note',
    Contact: 'contact',
    Worksite: 'worksite',
    OrderSlip: 'order_slip',
    DeliverySlip: 'delivery_slip',
} as const;

export type AiEntityType = (typeof AI_ENTITY_TYPE)[keyof typeof AI_ENTITY_TYPE];

export const ENTITY_ICON_MAP: Record<string, string> = {
    [AI_ENTITY_TYPE.Invoice]: 'fa-regular fa-file-invoice',
    [AI_ENTITY_TYPE.Quote]: 'fa-regular fa-file-invoice',
    [AI_ENTITY_TYPE.CreditNote]: 'fa-regular fa-file-invoice',
    [AI_ENTITY_TYPE.Contact]: 'fa-regular fa-address-book',
    [AI_ENTITY_TYPE.Worksite]: 'fa-regular fa-hard-hat',
};

export const ENTITY_LABEL_KEY_MAP: Record<string, string> = {
    [AI_ENTITY_TYPE.Invoice]: 'invoice_document_type.invoice',
    [AI_ENTITY_TYPE.Quote]: 'invoice_document_type.quote',
    [AI_ENTITY_TYPE.CreditNote]: 'invoice_document_type.credit-note',
    [AI_ENTITY_TYPE.OrderSlip]: 'invoice_document_type.order-slip',
    [AI_ENTITY_TYPE.DeliverySlip]: 'invoice_document_type.delivery-slip',
    [AI_ENTITY_TYPE.Contact]: 'form.labels.contact',
    [AI_ENTITY_TYPE.Worksite]: 'form.labels.worksite',
};

export const INVOICE_TYPES = [
    AI_ENTITY_TYPE.Invoice,
    AI_ENTITY_TYPE.Quote,
    AI_ENTITY_TYPE.CreditNote,
    AI_ENTITY_TYPE.OrderSlip,
    AI_ENTITY_TYPE.DeliverySlip,
] as const;

export const SPECIAL_SELECTION = {
    FreeLine: '__free_line__',
    CreateNew: '__create_new__',
} as const;

const invoiceTypeSlugMap: Record<string, string> = {
    quote: 'quotes',
    invoice: 'invoices',
    credit_note: 'credit-notes',
    order_slip: 'order-slips',
    delivery_slip: 'delivery-slips',
};

export function navigateToEntity(type: string, id: string): void {
    if (type === 'contact') {
        navigateTo(`/contacts/${id}`);
    } else if (type === 'worksite') {
        navigateTo(`/worksite/worksite/${id}/informations`);
    } else {
        const slug = invoiceTypeSlugMap[type] ?? `${type}s`;
        navigateTo(`/invoicing/${slug}/${id}/edit`);
    }
}

